import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from '../../../shared/services/order.service';

@Component({
  selector: 'app-footer-one',
  templateUrl: './footer-one.component.html',
  styleUrls: ['./footer-one.component.scss'],
})
export class FooterOneComponent implements OnInit {

  @Input() class: string = 'footer-light  light-layout-fondo' // Default class 
  // @Input() themeLogo: string ='https://izzimoviles.s3.us-east-1.amazonaws.com/Imagenes/GIGMAX_WHITE.png'; // Default Logo
  @Input() themeLogo: string = 'assets/images/icon/logo_gigmax.webp'; //'assets/images/icon/logo_bt_white.png'; // Default Logo
  @Input() newsletter: boolean = true; // Default True

  public today: number = Date.now();

  constructor(private router: Router,
    private orderService: OrderService) { }

  mail: string;

  ngOnInit(): void {
  }

  ir(){
    this.router.navigateByUrl('/pages/contact')
  }

  goToRegister() {
    this.orderService.setSharedMail(this.mail);
    this.router.navigateByUrl('/pages/registro-usuario');
  }
}
